<!-- ══════════════════════════════════════════════════════════════
Encabezado
═══════════════════════════════════════════════════════════════ -->
<app-page-title [title]="title()"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="title()" (retry)="init()"></app-page-loader>

<app-kpi-strip [kpis]="kpis" [active]="activeKpi" (activeChange)="setKpi($event)"></app-kpi-strip>

<!-- Resumen por lote y código de producto -->
@if (lotSummary.length) {
  <section class="lot-summary">
    <button type="button" class="lot-summary__head" (click)="showLots = !showLots" [attr.aria-expanded]="showLots">
      <mat-icon>inventory</mat-icon>
      <b>Resumen por lote y código</b>
      <span>{{ lotSummary.length }} lote(s) con incidencias en el periodo</span>
      <mat-icon class="lot-summary__caret">{{ showLots ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>
    @if (showLots) {
      <div class="lot-summary__table">
        <table>
          <thead><tr><th>Código</th><th>Descripción</th><th>Lote</th><th class="r">Incidencias</th><th class="r">Sin justificar</th><th class="r">De calidad</th><th>Hospitales</th></tr></thead>
          <tbody>
            @for (l of lotSummary.slice(0, 8); track l.code + l.batch) {
              <tr (click)="filterByLot(l)" matTooltip="Ver estas incidencias">
                <td><code>{{ l.code }}</code></td><td>{{ l.description }}</td><td><b>{{ l.batch }}</b></td>
                <td class="r b">{{ l.total }}</td><td class="r">{{ l.open }}</td>
                <td class="r" [class.q]="l.quality > 0">{{ l.quality }}</td><td>{{ l.hospitals }}</td>
              </tr>
            }
          </tbody>
        </table>
        @if (lotSummary.length > 8) { <p class="muted">+{{ lotSummary.length - 8 }} lotes más · el detalle completo está en Reportes → Incidencias por lote y producto.</p> }
      </div>
    }
  </section>
}

<!-- ══════════════════════════════════════════════════════════════
Filtros + Tabla
═══════════════════════════════════════════════════════════════ -->
<div class="table-section">

  <div class="filter-bar filter-bar--flush">
  <div class="filter-card">
    <app-search-pill [value]="searchText" placeholder="Folio, hospital, médico, pieza…" (valueChange)="applySearch($event)"></app-search-pill>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Periodo</mat-label>
      <mat-date-range-input [rangePicker]="periodPicker">
        <input matStartDate [(ngModel)]="periodStart" placeholder="Inicio" (dateChange)="loadIncidents()">
        <input matEndDate [(ngModel)]="periodEnd" placeholder="Fin" (dateChange)="loadIncidents()">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="periodPicker"></mat-datepicker-toggle>
      <mat-date-range-picker #periodPicker></mat-date-range-picker>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tipo</mat-label>
      <mat-select [(value)]="typeFilter" (selectionChange)="loadIncidents()">
        <mat-option [value]="''">Todos</mat-option>
        @for (t of types; track t) {
          <mat-option [value]="t">{{ t }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-filter-chips [chips]="filterChips" [count]="dataSource.filteredData.length" [total]="dataSource.data.length" noun="incidencias" (remove)="removeChip($event)" (clear)="clearFilters()"></app-filter-chips>
  </div>

  <div class="list-actions">
    <button mat-stroked-button (click)="pageLoad.refresh(loadIncidents())"><mat-icon>refresh</mat-icon> Actualizar</button>
    <button mat-stroked-button (click)="downloadExcel()" [disabled]="!dataSource.filteredData.length">
      <mat-icon>download</mat-icon> Descargar Excel
    </button>
    <button mat-flat-button color="primary" (click)="openCreate()">
      <mat-icon>add</mat-icon> Reportar incidencia
    </button>
  </div>

  <app-selection-bar [count]="sel.count" (export)="downloadExcel(sel.selected)" (clear)="sel.clear()"></app-selection-bar>

  <mat-paginator [hidden]="listView.mode !== 'table'" [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>

  @if (loading()) {
    <div class="loading-row">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Cargando incidencias...</span>
    </div>
  }


  @if (listView.mode === 'cards') {
    <div class="inv-cards cat-cards">
      @for (i of dataSource.filteredData; track i.id) {
        <div class="cat-card" [class.cat-card--selected]="sel.isSelected(i)">
          <div class="cat-card__head">
            <mat-checkbox color="primary" [checked]="sel.isSelected(i)" (change)="sel.toggle(i)" matTooltip="Seleccionar"></mat-checkbox>
            <span class="cat-card__title">{{ i.folio }}</span>
            @if (i.justified) { <span class="chip chip--ok">Justificada</span> } @else { <span class="chip chip--open">Sin justificar</span> }
          </div>
          <div class="cat-card__body">
            <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ formatDate(i.createdOn) }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Tipo:</span><span class="cat-card__value">{{ i.type }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Hospital:</span><span class="cat-card__value">{{ i._place }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Médico:</span><span class="cat-card__value">{{ i._doctor }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Pieza:</span><span class="cat-card__value">{{ i._piece }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Folio/Remisión:</span><span class="cat-card__value">{{ i._reference }}{{ i._service ? ' · ' + i._service : '' }}</span></div>
            @if (i.priority) {<div class="cat-card__field"><span class="cat-card__label">Prioridad:</span><span class="cat-card__value"><span [class]="priorityClass(i.priority)">{{ i.priority }}</span></span></div>}
            <div class="cat-card__field"><span class="cat-card__label">MPXR:</span><span class="cat-card__value">{{ i.mpxr || '—' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Justificado:</span><span class="cat-card__value">{{ i.justified ? 'Sí' : 'No' }}</span></div>
            <div class="cat-card__field"><span class="cat-card__label">Reportó:</span><span class="cat-card__value">{{ i.reportedByName || '—' }}</span></div>
          </div>
          <div class="cat-card__actions">
            <button mat-icon-button color="primary" matTooltip="Seguimiento" (click)="openEdit(i)"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button matTooltip="Imprimir bitácora (formato GA)" aria-label="Imprimir bitácora" [disabled]="printing() === i.id" (click)="printBitacora(i)"><mat-icon>print</mat-icon></button>
            @if (canMpxr()) {
              <button mat-icon-button [matTooltip]="i.mpxr ? 'Cambiar MPXR' : 'Agregar MPXR'" aria-label="MPXR" [disabled]="reviewing() === i.id" (click)="editMpxr(i)"><mat-icon>tag</mat-icon></button>
            }
            @if (canJustify()) {
              <button mat-icon-button [matTooltip]="i.justified ? 'Quitar justificado' : 'Marcar como justificado'" aria-label="Justificado" [disabled]="reviewing() === i.id" (click)="toggleJustified(i)" [class.is-justified]="i.justified"><mat-icon>{{ i.justified ? 'verified' : 'gpp_maybe' }}</mat-icon></button>
            }
          </div>
        </div>
      }
      @if (dataSource.filteredData.length === 0) {
        <p class="inv-cards__empty">Sin incidencias con estos filtros</p>
      }
    </div>
  }

  <div class="table-container mat-elevation-z2" [hidden]="listView.mode !== 'table'">
    <table mat-table [dataSource]="dataSource">

      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox color="primary" (change)="$event ? sel.toggleAll() : null" [checked]="sel.allSelected()" [indeterminate]="sel.someSelected()" matTooltip="Seleccionar todos los visibles"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="select-cell">
          <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="$event ? sel.toggle(row) : null" [checked]="sel.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="folio">
        <th mat-header-cell *matHeaderCellDef>Folio</th>
        <td mat-cell *matCellDef="let i"><code class="folio-badge">{{ i.folio }}</code></td>
      </ng-container>

      <ng-container matColumnDef="createdOn">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let i">{{ formatDate(i.createdOn) }}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let i">{{ i.type }}</td>
      </ng-container>

      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Hospital</th>
        <td mat-cell *matCellDef="let i">{{ i._place }}</td>
      </ng-container>

      <ng-container matColumnDef="doctor">
        <th mat-header-cell *matHeaderCellDef>Médico</th>
        <td mat-cell *matCellDef="let i">{{ i._doctor }}</td>
      </ng-container>

      <ng-container matColumnDef="piece">
        <th mat-header-cell *matHeaderCellDef>Pieza</th>
        <td mat-cell *matCellDef="let i">{{ i._piece }}</td>
      </ng-container>

      <ng-container matColumnDef="reference">
        <th mat-header-cell *matHeaderCellDef>Folio/Remisión</th>
        <td mat-cell *matCellDef="let i">
          <div class="ref-cell">
            <span>{{ i._reference }}</span>
            @if (i._service) {
              <span class="ref-service">{{ i._service }}</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="priority">
        <th mat-header-cell *matHeaderCellDef>Prioridad</th>
        <td mat-cell *matCellDef="let i">
          @if (i.priority) {
            <span [class]="priorityClass(i.priority)">{{ i.priority }}</span>
          } @else {
            <span class="muted">—</span>
          }
        </td>
      </ng-container>


      <ng-container matColumnDef="quality">
        <th mat-header-cell *matHeaderCellDef>Clasificación</th>
        <td mat-cell *matCellDef="let i">
          @if (i.qualityClass) {
            <span class="chip" [class.chip--high]="i.qualityClass === 'CALIDAD'" [class.chip--ok]="i.qualityClass !== 'CALIDAD'"
                  [matTooltip]="i.qualitySource === 'MANUAL' ? 'Corregida por ' + (i.qualityBy || 'una persona') : 'Sugerida por el modelo · ' + ((i.qualityScore || 0) * 100).toFixed(0) + '% de confianza'">
              {{ i.qualityClass === 'CALIDAD' ? 'Calidad' : 'No calidad' }}@if (i.qualitySource === 'MANUAL') { ✓ }
            </span>
          } @else { <span class="muted">—</span> }
        </td>
      </ng-container>

      <ng-container matColumnDef="mpxr">
        <th mat-header-cell *matHeaderCellDef>MPXR</th>
        <td mat-cell *matCellDef="let i">
          @if (i.mpxr) { <code class="folio-badge" [matTooltip]="i.mpxrBy ? 'Capturó: ' + i.mpxrBy : ''">{{ i.mpxr }}</code> }
          @else { <span class="muted">—</span> }
        </td>
      </ng-container>

      <ng-container matColumnDef="justified">
        <th mat-header-cell *matHeaderCellDef>Justificado</th>
        <td mat-cell *matCellDef="let i">
          @if (i.justified) {
            <span class="chip chip--ok" [matTooltip]="i.justifiedBy ? 'Justificó: ' + i.justifiedBy : ''">Sí</span>
          } @else { <span class="muted">No</span> }
        </td>
      </ng-container>

      <ng-container matColumnDef="reportedByName">
        <th mat-header-cell *matHeaderCellDef>Reportó</th>
        <td mat-cell *matCellDef="let i">{{ i.reportedByName ?? '' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let i">
          <button mat-icon-button color="primary" matTooltip="Seguimiento"
            (click)="openEdit(i)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Imprimir bitácora (formato GA)" aria-label="Imprimir bitácora"
            [disabled]="printing() === i.id" (click)="printBitacora(i)">
            <mat-icon>print</mat-icon>
          </button>
          @if (canMpxr()) {
            <button mat-icon-button [matTooltip]="i.mpxr ? 'Cambiar MPXR' : 'Agregar MPXR'" aria-label="MPXR"
              [disabled]="reviewing() === i.id" (click)="editMpxr(i)">
              <mat-icon>tag</mat-icon>
            </button>
          }
          @if (canJustify()) {
            <button mat-icon-button [matTooltip]="i.justified ? 'Quitar justificado' : 'Marcar como justificado'" aria-label="Justificado"
              [disabled]="reviewing() === i.id" (click)="toggleJustified(i)" [class.is-justified]="i.justified">
              <mat-icon>{{ i.justified ? 'verified' : 'gpp_maybe' }}</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Corregir clasificación (calidad / no calidad)" aria-label="Clasificación"
              [disabled]="reviewing() === i.id" [matMenuTriggerFor]="qm">
              <mat-icon>rule</mat-icon>
            </button>
            <mat-menu #qm="matMenu">
              <button mat-menu-item (click)="setQuality(i, 'CALIDAD')"><mat-icon>report</mat-icon> Es de calidad</button>
              <button mat-menu-item (click)="setQuality(i, 'NO CALIDAD')"><mat-icon>check_circle</mat-icon> No es de calidad</button>
            </mat-menu>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;" class="table-row"></tr>

      <tr class="no-data-row" *matNoDataRow>
        <td [attr.colspan]="columns.length">
          <div class="no-data">
            <mat-icon>task_alt</mat-icon>
            <span>Sin incidencias con estos filtros</span>
          </div>
        </td>
      </tr>
    </table>
  </div>

</div>
